








import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { 在庫商品区分型 } from '@/type/stock/item';

@Component({})
export default class StockItemClassSelector extends Vue {
  @Prop({default: null})
  private value!: 在庫商品区分型;

  @Emit('input')
  private update(event: Event): 在庫商品区分型 | null {
    const target = event.target as HTMLInputElement;
    if (target.value) {
        return target.value as 在庫商品区分型;
    }
    return null;
  }
}
